import type { SupplierDownloadDto } from './dto';
import type { DownloadStatus, SupplierDownload } from './types';

const STATUS_FROM_DTO: Record<string, DownloadStatus> = {
    finished: 'finished',
    completed: 'finished',
    running: 'running',
    in_progress: 'running',
    started: 'running',
    failed: 'failed',
    error: 'failed',
};

function toDate(value: string | null | undefined): Date | null {
    if (typeof value !== 'string' || value.trim() === '') return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function toSupplierDownload(dto: SupplierDownloadDto): SupplierDownload {
    const data = dto?.data ?? null;
    const key = data?.status?.toLowerCase().trim();

    return {
        id: data?.id ?? '',
        status: (key !== undefined && STATUS_FROM_DTO[key]) || 'unknown',
        percentage: Math.min(Math.max(data?.load_percentage ?? 0, 0), 100),
        finishedAt: toDate(data?.download_data),
        duration: data?.download_completion_time ?? '—',
    };
}